import { RECEIVE_CONTENT, REQUEST_CONTENT } from '../actions/content'

export const initialState = {
  isFetching: false,
  labels: [],
  status: 'initial',
}

function content(state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST_CONTENT:
      return {
        ...state,
        isFetching: true,
      }
    case RECEIVE_CONTENT:
      return {
        isFetching: false,
        ...action.data,
      }
    default:
      return state
  }
}

export default content
